import { NbToastrConfig } from '@nebular/theme';

interface ToastrConfigOptions {
    success?: Partial<NbToastrConfig>;
    info?: Partial<NbToastrConfig>;
    warning?: Partial<NbToastrConfig>;
    danger?: Partial<NbToastrConfig>;
}

export const ToastrConfigs: ToastrConfigOptions = {
    success: { status: 'success', icon: 'checkmark-outline' },
    info: { status: 'info', icon: 'checkmark-outline' },
    warning: {status: 'warning', icon: 'alert-triangle'},
    danger: { status: 'danger', icon: 'close-outline'}
};
